import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToSection } from "../lib/scroll";

const FinalCTA = () => (
  <section data-testid="final-cta-section" className="relative z-10 flex min-h-[85vh] items-center py-28">
    <div className="mx-auto w-full max-w-5xl px-6 sm:px-10 text-center">
      <Reveal>
        <p className="font-display text-[11px] font-medium tracking-[0.5em] text-white/50 uppercase">
          Your Move
        </p>
      </Reveal>
      <Reveal i={1}>
        <h2 data-testid="final-cta-heading" className="font-display mt-6 text-4xl sm:text-5xl lg:text-7xl font-semibold tracking-tighter leading-[1.02]">
          <span className="chrome-text">Ready To Launch</span>
          <br />
          Something Better?
        </h2>
      </Reveal>
      <Reveal i={2}>
        <p className="mx-auto mt-7 max-w-xl text-base md:text-lg font-light leading-relaxed text-white/55">
          Tell us about your business and let's build a website that gets you noticed.
        </p>
      </Reveal>
      <Reveal i={3}>
        <motion.button
          data-testid="final-cta-button"
          onClick={() => scrollToSection("contact")}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.96 }}
          className="group mt-10 inline-flex items-center gap-3 rounded-full bg-white px-10 py-5 text-sm font-semibold text-black shadow-[0_0_60px_rgba(255,255,255,0.15)]"
        >
          Start Your Project
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </motion.button>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
